import { Link } from "@tanstack/react-router";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import { type ITenant } from "@/hooks/useTenants";

interface TenantCardProps {
  tenant: ITenant;
}

export function TenantCard({ tenant }: TenantCardProps) {
  const { t } = useTranslation(["admin"]);

  return (
    <Link
      to="/admin/tenants/$tenantId"
      params={{ tenantId: tenant.tenantId }}
      className="block"
    >
      <Card className="flex cursor-pointer flex-col gap-3 transition-shadow hover:shadow-lg">
        <div className="flex items-start justify-between">
          <h3 className="text-lg font-medium">{tenant.name}</h3>
          <Badge variant={tenant.status === "ACTIVE" ? "default" : "error"}>
            {tenant.status}
          </Badge>
        </div>
        <div className="flex items-center gap-1.5 text-sm text-muted-foreground">
          <Users className="h-4 w-4" />
          <span>
            {t("admin:tenants.memberCount", { count: tenant.memberCount })}
          </span>
        </div>
      </Card>
    </Link>
  );
}
